import { connect } from 'react-redux';

import closeMegaMenu from 'redux/modules/mega-menu/actions/close-mega-menu';

import { MenuCard } from './MenuCard';

export default connect(null, { closeMegaMenu })(MenuCard);
